<template>
    <div class="py-8">
        <div class="container">
            <div
                class="mx-auto grid max-w-5xl gap-6 md:gap-8"
                :class="gridColsClass"
            >
                <!-- Users (no public page to link to) -->
                <div v-if="stats.usersCount > 0" class="text-center">
                    <div class="mb-1 text-2xl font-bold text-gray-900 dark:text-white md:text-3xl">
                        {{ formatNumber(stats.usersCount) }}
                    </div>
                    <div class="text-sm text-gray-600 dark:text-gray-400">
                        používateľov
                    </div>
                </div>

                <!-- Mentors -->
                <NuxtLink to="/mentori" class="text-center group hover:opacity-80 transition-opacity">
                    <div class="mb-1 text-2xl font-bold text-gray-900 dark:text-white md:text-3xl">
                        {{ formatNumber(stats.mentorsCount) }}
                    </div>
                    <div class="text-sm text-gray-600 dark:text-gray-400">
                        mentorov
                    </div>
                </NuxtLink>

                <!-- Organizations -->
                <NuxtLink to="/organizacie" class="text-center group hover:opacity-80 transition-opacity">
                    <div class="mb-1 text-2xl font-bold text-gray-900 dark:text-white md:text-3xl">
                        {{ formatNumber(stats.orgsCount) }}
                    </div>
                    <div class="text-sm text-gray-600 dark:text-gray-400">
                        organizácií
                    </div>
                </NuxtLink>

                <!-- Opportunities span jobs, volunteering and education, so there is no single page to link to -->
                <div class="text-center">
                    <div class="mb-1 text-2xl font-bold text-gray-900 dark:text-white md:text-3xl">
                        {{ formatNumber(stats.opportunitiesCount) }}
                    </div>
                    <div class="text-sm text-gray-600 dark:text-gray-400">
                        príležitostí
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Statistics {
    usersCount: number
    mentorsCount: number
    orgsCount: number
    opportunitiesCount: number
}

const stats = ref<Statistics>({
    usersCount: 0,
    mentorsCount: 0,
    orgsCount: 0,
    opportunitiesCount: 0
})

// Compute grid columns based on visible stats
const gridColsClass = computed(() => {
    const hasUsers = stats.value.usersCount > 0
    // 3 Typesense stats (mentors, orgs, opportunities) + users if available
    const totalStats = 3 + (hasUsers ? 1 : 0)

    if (totalStats === 4) return 'grid-cols-2 md:grid-cols-4'
    return 'grid-cols-3'
})

// Format number with spaces for thousands
function formatNumber(num: number): string {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

// Fetch statistics
onMounted(async () => {
    try {
        const data = await $fetch('/api/homepage/statistics')
        stats.value = data
    } catch (error) {
        console.error('Error fetching statistics:', error)
    }
})
</script>
